const getAlignment = (alignment) => {
  let formattedAlignment;

  switch (alignment) {
    case 'Center':
      formattedAlignment = 'center';
      break;
    case 'Bottom':
      formattedAlignment = 'flex-end';
      break;
    case 'Top':
      formattedAlignment = 'flex-start';
      break;
  }

  return formattedAlignment;
};

export default getAlignment;
